import { render } from "./Initiators.vue?vue&type=template&id=71864445"
import script from "./Initiators.vue?vue&type=script&lang=js"
export * from "./Initiators.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__